export default "__VITE_ASSET__hK59SIaf__"